<template>
  <div class="m-l-50 m-t-30 w-500">
    <el-form ref="form" :model="form" :rules="rules" label-width="130px">
      <el-form-item label="表单标识" prop="name">
        <span>form_</span>
        <el-input v-model.trim="form.name" class="h-40 w-150"></el-input>
      </el-form-item>
      <el-form-item label="表单名称" prop="title">
        <el-input v-model.trim="form.title" class="h-40 w-200"></el-input>
      </el-form-item>
      <!-- <el-form-item label="引擎类别" prop="engine">
        <el-select v-model="form.engine" placeholder="请选择引擎类别" class="w-200">
          <el-option v-for="item in engineOptions" :label="item.id" :value="item.id"></el-option>
        </el-select>
      </el-form-item> -->
      <el-form-item label="表描述">
        <el-input v-model.trim="form.des" class="h-40 w-200"></el-input>
      </el-form-item>
      <el-form-item label="复制表" prop="model_id">
        <el-select v-model="form.model_id" clearable :filterable="true">
          <el-option v-for="option in models" :label="option.title" :value="option.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="add()" :loading="isLoading">提交</el-button>
        <el-button @click="goback()">返回</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
  import http from '../../assets/js/http'
  import _verify from '../../assets/js/verify'
  export default {
    data() {
      return {
        isLoading: false,
        rules: {
          name: [
            { required: true, message: '请输入表单标识' },
            { validator: this.isContainUpperCase, trigger: 'blur' },
            { validator: this.isEngAndNum, trigger: 'blur' }
          ],
          title: [
            { required: true, message: '请输入模型名称' }
          ]
          // engine: [
          //   { required: true, message: '请选择模型引擎' }
          // ],
          // des: [
          //   { required: true, message: '请输入表描述' }
          // ]
        },
        engineOptions: [
          {
            id: 'MyISAM'
          },
          {
            id: 'InnoDB'
          }
        ],
        form: {
          name: '',
          title: '',
          // engine: '',
          des: '',
          model_id: ''
        },
        models: [] // 模型列表
      }
    },
    methods: {
      add() {
        this.$refs.form.validate((pass) => {
          if (pass) {
            this.isLoading = !this.isLoading
            let postData = JSON.parse(JSON.stringify(this.form))
            postData.name = 'form_' + postData.name
            this.apiPost('form/models', postData).then((res) => {
              if (res.code == 200) {
                _g.toastMsg(this, 'success', '添加成功')
                _g.clearVuex('setUsers')
                setTimeout(() => {
                  this.goback()
                }, 1500)
              } else {
                this.isLoading = !this.isLoading
                _g.dealError(this, res)
              }
            })
          }
        })
      },
      getModel() {  // 获取模型列表
        this.apiGet('form/models').then((res) => {
          this.loading = false
          if (res.code == 200) {
            this.models = res.data.list
          } else {
            _g.dealError(this, res)
          }
        })
      },
      isEngAndNum(rule, value, callback) {
        if (!_verify.isEngAndNum(value)) {
          callback(new Error('请输入数字或英文'))
        } else {
          callback()
        }
      },
      isContainUpperCase(rule, value, callback) {
        if (!_verify.isContainUpperCase(value)) {
          callback(new Error('表单标识不能输入大写字母'))
        } else {
          callback()
        }
      },
      goback() {
        router.go(-1)
      }
    },
    created() {
      this.getModel()
    },
    mixins: [http]
  }
</script>


// WEBPACK FOOTER //
// add.vue?15a650ee